import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Box, Typography, Avatar } from '@mui/material';
import Label from './Label';
import { NETWORK } from '../config';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
  isCollapse: PropTypes.bool,
};

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

export default function Logo({ isCollapse, disabledLink = false, sx }) {
  const logo = (
    <RootStyle
      sx={{
        ...sx, ...(isCollapse && {
          bgcolor: 'transparent',
        }),
      }}
    >
      <Avatar src="/icons/stakebin.png" alt="logo" />

      {!isCollapse &&
        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0,
            }),
            display: 'flex', flexDirection: 'column', alignItems: 'center'
          }}
        >
          <Typography variant="h5" sx={{ color: 'text.primary', textAlign: 'center' }}>
            StakeBin
          </Typography>
          <Label color="primary">{NETWORK}</Label>
        </Box>
      }
    </RootStyle>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <Link underline="none" color="inherit" component={RouterLink} to="/" sx={{ display: 'inline-flex' }}>{logo}</Link>;
}
